module.exports = __webpack_public_path__ + "static/media/Business_PNG.c121b6d7.png";